import React from "react";
import { Create, SimpleForm, TextInput, required, ReferenceInput, SelectInput } from "react-admin";

import useReferenceEnumInput from "../../hooks/useReferenceEnumInput";

const FileCreate = (props) => {
	const { ReferenceEnumInput: ReferenceEnumInputFileStatus } = useReferenceEnumInput(
		"enum_file_type",
		{
			label: "Type",
			source: "type",
			optionText: "value",
			optionValue: "value",
		}
	);

	return (
		<Create {...props}>
			<SimpleForm variant="standard">
				<TextInput source="src" validate={required()} />
				<TextInput source="alt" validate={required()} />
				<ReferenceEnumInputFileStatus validate={required()} />
				<ReferenceInput source="campaign_id" reference="campaign">
					<SelectInput label="Campagne" optionText="title" />
				</ReferenceInput>
			</SimpleForm>
		</Create>
	);
};

export default FileCreate;
